import React from 'react'

import { cn } from '@/lib'

const TEXT_SIZES = {
  56: 'text-size-56',
  36: 'text-size-36',
  28: 'text-size-28',
  22: 'text-size-22',
  18: 'text-size-18',
  16: 'text-size-16',
  14: 'text-size-14',
  12: 'text-size-12',
  10: 'text-size-10',
}

const TEXT_COLORS = {
  while: 'text-white-100',
  'white-48': 'text-white-48',
  black: 'text-black-100',
  main: 'text-main-100',
  green: 'text-green-100',
  red: 'text-red-100',
}

type AsProp<C extends React.ElementType> = {
  as?: C
}

type PropsToOmit<C extends React.ElementType, P> = keyof (AsProp<C> & P)

type PolymorphicComponentProp<C extends React.ElementType, Props = {}> = React.PropsWithChildren<Props & AsProp<C>> &
  Omit<React.ComponentPropsWithoutRef<C>, PropsToOmit<C, Props>>

type PolymorphicComponentPropWithRef<C extends React.ElementType, Props = {}> = PolymorphicComponentProp<C, Props> & {
  // ref?: PolymorphicRef<C>
}

type TextProps<C extends React.ElementType> = PolymorphicComponentPropWithRef<
  C,
  {
    size?: keyof typeof TEXT_SIZES
    color?: keyof typeof TEXT_COLORS
    isLoading?: boolean
  }
>

type TextComponent = <C extends React.ElementType = 'span'>(props: TextProps<C>) => React.ReactElement | null

export const Text: TextComponent = (<C extends React.ElementType = 'div'>({
  as,
  children,
  className,
  size = 14,
  color = 'while',
  isLoading,
  ...props
}: TextProps<C>): React.ReactElement | null => {
  const Component = as || 'div'
  const textSize = TEXT_SIZES[size]
  const textColor = TEXT_COLORS[color]
  return (
    <Component
      className={cn(
        textSize,
        textColor,
        {
          'optimex-shiny-text text-white-48': isLoading,
        },
        className
      )}
      style={{ animationDuration: '1s' }}
      {...props}
    >
      {children}
    </Component>
  )
}) as TextComponent
